// extracted by mini-css-extract-plugin
module.exports = {"container":"Auth_container__dtmwa","inner":"Auth_inner__k_0zu","tabs":"Auth_tabs__2fc95","tabItem":"Auth_tabItem__r__wR","active":"Auth_active__DQFTY"};